import PropTypes from 'prop-types';
import { useChannelPendingStatus, useChannelSettings } from '../../../../../Slice';

export const SmartButton = ({ className, onClick, isLoading, channelId }) => {
   const { accessMode } = useChannelSettings(channelId) || {};
   const pendingStatus = useChannelPendingStatus(channelId);
   const isRequested = Number(pendingStatus) === 1;
   const baseLabel = accessMode === 1 ? 'Join' : 'Request';
   const label = isRequested ? 'Requested' : baseLabel;

   return (
      <button
         className={`${className} ${isLoading ? 'loading' : ''}`}
         disabled={isLoading || isRequested}
         onClick={() => onClick(label)}>
         {isLoading ? 'Sending Request...' : label}
      </button>
   );
};

SmartButton.propTypes = {
   className: PropTypes.string,
   onClick: PropTypes.func.isRequired,
   isLoading: PropTypes.bool,
   channelId: PropTypes.string,
};
